var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsUpDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C363F",
    d: "M13.2422 16q-.4376 0-.7188-.2812-.2812-.2814-.2812-.7188V5h-2.25q-.4688-.0312-.6875-.4375-.1875-.4687.125-.8125l3.25-3.5q.2499-.25.5625-.25t.5625.25l3.25 3.5q.3125.3438.125.8125-.2188.4063-.6563.4375h-2.2812v10q0 .4374-.2813.7188-.2813.2812-.7187.2812M4.7578 0q.4375 0 .7188.2813T5.7578 1v10h2.25q.4688.0313.6875.4375.1875.4688-.125.8125l-3.25 3.5q-.2499.25-.5625.25t-.5625-.25l-3.25-3.5q-.3125-.3437-.125-.8125.2188-.4062.6563-.4375h2.2812V1q0-.4374.2813-.7187T4.7578 0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowsUpDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrows-up-down.4c95e1cf90db0e4c538d5ddabf813872.svg";